export const typeOptions = [
  {
    title: "文字导航",
    type: "elevatorText",
    iconName: "nav-text-icon",
    iconActiveName: "nav-text-active-icon"
  },
  {
    title: "图文型",
    type: "elevatorImgText",
    iconName: "nav-imgText-icon",
    iconActiveName: "nav-imgText-active-icon"
  },
  {
    title: "图片导航",
    type: "elevatorImg",
    iconName: "nav-img-icon",
    iconActiveName: "nav-img-active-icon"
  }
];
export const styleOptions = [
  {
    label: "固定",
    value: "fixed"
  },
  {
    label: "横向滑动",
    value: "row"
  }
];



// WEBPACK FOOTER //
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/GraphicNavigation/options.js